<template>
    <div>
        <div class="row" v-if="showInvoiceFreq">
            <div class="column small-12 medium-6 large-4 paddingtop0">
                <b-field
                    :label="invoiceFreqLabel"
                    :message="invoiceFreqMessage"
                    :type="invoiceFreqType"
                >
                    <b-select
                        :value="safeValue.invoice_freq"
                        placeholder="Maak een keuze"
                        expanded
                        @input="updateField('invoice_freq', $event)"
                    >
                        <option value="week_1">{{ invoiceFreqLongLabel('week_1') }}</option>
                        <option value="week_2">{{ invoiceFreqLongLabel('week_2') }}</option>
                        <option value="week_3">{{ invoiceFreqLongLabel('week_3') }}</option>
                        <option value="week_4">{{ invoiceFreqLongLabel('week_4') }}</option>
                        <option value="week_5">{{ invoiceFreqLongLabel('week_5') }}</option>
                        <option value="month">{{ invoiceFreqLongLabel('month') }}</option>
                        <option value="quarter">{{ invoiceFreqLongLabel('quarter') }}</option>
                        <option value="halfyear">{{ invoiceFreqLongLabel('halfyear') }}</option>
                        <option value="year">{{ invoiceFreqLongLabel('year') }}</option>
                    </b-select>
                </b-field>
            </div>
        </div>

        <div class="row" v-if="showWeeklyPriceNotice && isWeeklyInvoiceFreq">
            <div class="column small-12 medium-10 large-8">
                <b-notification type="is-info is-light" :closable="false" class="margintop10">
                    <strong>Dagprijs</strong><br>
                    De prijs wordt omgerekend naar een dagtarief en vervolgens vermenigvuldigd met het aantal dagen in de factuurperiode.<br>
                    <strong>Voorbeeld:</strong> Product €100 → €100 / 31 dagen = €3,23 per dag.<br>
                    Voor een periode van {{ weeklyWeeks }} {{ weeklyWeeks === 1 ? 'week' : 'weken' }} ({{ weeklyDays }} dagen) = €{{ weeklyExampleTotal }}
                </b-notification>
            </div>
        </div>

        <div class="row" v-if="showPaymentType">
            <div class="column small-12 medium-6 large-4">
                <b-field
                    :label="paymentTypeLabel"
                    :message="paymentTypeMessage"
                    :type="paymentTypeType"
                >
                    <b-select
                        :value="safeValue.payment_type"
                        placeholder="Maak een keuze"
                        expanded
                        @input="updateField('payment_type', $event)"
                    >
                        <option
                            v-for="(paymentType, key) in normalizedPaymentTypes"
                            :key="`payment_type_${key}`"
                            :value="key"
                            :disabled="key === 'incasso' && disableIncasso"
                        >
                            {{ paymentType.label }}{{ key === 'incasso' && disableIncasso ? ' (niet beschikbaar)' : '' }}
                        </option>
                    </b-select>
                </b-field>
            </div>
        </div>
    </div>
</template>

<script>
import invoiceFreqMixin from '@/mixins/invoiceFreqMixin'

export default {
    name: 'ContractBillingSettingsFields',
    mixins: [invoiceFreqMixin],
    props: {
        value: {
            type: Object,
            default: () => ({})
        },
        paymentTypes: {
            type: Object,
            default: () => ({
                incasso: { label: 'Automatische incasso' },
                manual: { label: 'Handmatig' }
            })
        },
        disableIncasso: {
            type: Boolean,
            default: false
        },
        showInvoiceFreq: {
            type: Boolean,
            default: true
        },
        showPaymentType: {
            type: Boolean,
            default: true
        },
        invoiceFreqLabel: {
            type: String,
            default: 'Facturatie frequentie'
        },
        paymentTypeLabel: {
            type: String,
            default: 'Betaalmethode'
        },
        invoiceFreqMessage: {
            type: String,
            default: ''
        },
        invoiceFreqType: {
            type: String,
            default: ''
        },
        paymentTypeMessage: {
            type: String,
            default: ''
        },
        paymentTypeType: {
            type: String,
            default: ''
        },
        showWeeklyPriceNotice: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        safeValue() {
            return this.value || {}
        },
        normalizedPaymentTypes() {
            return this.paymentTypes || {}
        },
        isWeeklyInvoiceFreq() {
            const freq = this.safeValue?.invoice_freq
            return typeof freq === 'string' && freq.indexOf('week_') === 0
        },
        weeklyWeeks() {
            if (!this.isWeeklyInvoiceFreq) return 0
            const parts = String(this.safeValue.invoice_freq).split('_')
            const weeks = parseInt(parts[1], 10)
            return isNaN(weeks) ? 1 : weeks
        },
        weeklyDays() {
            return this.weeklyWeeks * 7
        },
        weeklyExampleTotal() {
            const total = (100 / 31) * this.weeklyDays
            return total.toFixed(2).replace('.', ',')
        }
    },
    methods: {
        updateField(field, nextValue) {
            this.$emit('input', {
                ...this.safeValue,
                [field]: nextValue
            })
        }
    }
}
</script>

